<template>
  <div 
    :class="baseSelectClasses" 
    class="base-select"
  >
    <select
      v-bind="$attrs"
      :value="value"
      :disabled="isDisabled"
      @focus="$emit('focus', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @click="$emit('click')"
    >
      <slot />
    </select>

    <base-icon 
      class="base-select__icon" 
      icon="keyboard_arrow_down"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { computed } from "vue";

const props = defineProps({
  value: {
    type: [String, Number, Date, Boolean],
    default: "",
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["focus", "blur", "input", "change", "click"]);

const baseSelectClasses = computed(() => ({
  "base-select--is-full-width": props.isFullWidth,
  "base-select--is-disabled": props.isDisabled,
}));
</script>

<style lang="scss" scoped>
@import "./base-select.scss";
</style>
